module.exports = new __parcel__URL__("healingreductionbuff.6932728d.png").toString();